export const BankCardRoutes = {
    ROOT: "/shop-bank-card",
    PERSONAL_DATA: "/shop-bank-card/personal-data",
    NEW_PHONE: "/shop-bank-card/new-phone",
    NEW_ADDRESS: "/shop-bank-card/new-address",
    SUMMARY: "/shop-bank-card/summary",
    SIGNING: "/shop-bank-card/signing",
    SUCCESS: "/shop-bank-card/success"
};


// WEBPACK FOOTER //
// ./src/components/bankCard/BankCardRoutes.ts